import axios from 'axios';
import { DynamicQueryKeys, QueryKeys } from '../config';
import { useQuery } from '@tanstack/react-query';
import { Load } from '../../types';

export const useLastLoadByOrganizationLocation = (organizationLocationId: number) => {
    const queryKey = DynamicQueryKeys.lastLoadByOrganizationLocation(organizationLocationId);

    const query = useQuery<Load | null>({
        queryKey: [queryKey],
        queryFn: async () => {
            const load = await axios.get(`${API_BASE}/api/orders/${organizationLocationId}/last-order`);

            return load.data;
        },
        enabled: organizationLocationId > 0,
        staleTime: Infinity,
        cacheTime: 0,
    });

    return query;
}
